import { Map, List } from "immutable";

import {
  REGISTRATION_CODE_LIST_REQUEST,
  REGISTRATION_CODE_LIST_SUCCESS,
  REGISTRATION_CODE_LIST_FAILURE,
  REGISTRATION_CODE_READ_REQUEST,
  REGISTRATION_CODE_READ_SUCCESS,
  REGISTRATION_CODE_READ_FAILURE,
  REGISTRATION_CODE_UPDATE_REQUEST,
  REGISTRATION_CODE_UPDATE_SUCCESS,
  REGISTRATION_CODE_UPDATE_FAILURE,
  REGISTRATION_CODE_DELETE_REQUEST,
  REGISTRATION_CODE_DELETE_SUCCESS,
  REGISTRATION_CODE_DELETE_FAILURE,
  REGISTRATION_CODE_FORM_DESTROY,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function registrationCodes(
  state = Map({
    isLoading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[registrationCodes.reducers] registrationCodes(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case REGISTRATION_CODE_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case REGISTRATION_CODE_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case REGISTRATION_CODE_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case REGISTRATION_CODE_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case REGISTRATION_CODE_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case REGISTRATION_CODE_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case REGISTRATION_CODE_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case REGISTRATION_CODE_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case REGISTRATION_CODE_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case REGISTRATION_CODE_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case REGISTRATION_CODE_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case REGISTRATION_CODE_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case REGISTRATION_CODE_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set("form", action.form);

    default:
      return state;
  }
}

Logger.log("silly", `registrationCodes.reducers loaded.`);
